import { getConfig } from "../config";
import { loginDiscordAPI } from "./redux/reducers/user";

const AUTH_ENDPOINT = "https://discord.com/api/oauth2/authorize"

const RESPONSE_TYPE = "code"
const SCOPES = "identify"

function getQuerystring(key) {
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (const element of vars) {
        let pair = element.split("=");
        if (pair[0] == key) {
            return pair[1];
        }
    }
}

export function getDiscordAuthLink() {
    return AUTH_ENDPOINT + "?client_id=" + getConfig().DISCORD_CLIENT_ID + "&redirect_uri=" + getConfig().DISCORD_REDIRECT_URI + "&response_type=" + RESPONSE_TYPE + "&scope=" + SCOPES
}


export async function loginDiscord(dispatch){
    let code = getQuerystring("code")
    if (code != null) {
        await dispatch(loginDiscordAPI(code))
    }

}